import React from 'react';
import {    Routes,   Route,  } from "react-router-dom";
import { ConfigContext } from './context/config';

import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import './App.css';
 
import theme from './common/globalMuiTheme'; 
 
import { Box,  CircularProgress,  IconButton, Link, ThemeProvider, Tooltip } from '@mui/material';
 

import icona_testata_od from './img/logo_od.png';
import icona_facebook from './img/facebook.png';
import icona_instagram from './img/instagram.png';
import icona_vimeo from './img/vimeo.png';


import AiutoLogo from '@mui/icons-material/QuizSharp';
 
 




const FlussoNewUtente = React.lazy(() => import('./components/FlussoNewUtente'));
const FlussoLogin = React.lazy(() => import('./components/FlussoLogin'));
const RicordaPassword = React.lazy(() => import('./components/RicordaPassword'));
const CambioPassword = React.lazy(() => import('./components/CambioPassword'));
const AiutoView = React.lazy(() => import('./views/AiutoView'));
const AuthSecurityOD = React.lazy(() => import('./components/AuthSecurityOD'));
 
const InformaCollega = React.lazy(() => import('./components/InformaCollega'));

function CopyWriteView  (   ) {
  
 
 
  return (     

      <Box className="color_primary"    display="flex" flexDirection="row" alignItems="center"  width="100%"     justifyContent="center"   > 

      <Box style={{fontSize: '72%',  flexWrap: 'wrap', }}>© COPYRIGHT OPENDOCTOR 2022.  ALL RIGHTS RESERVED -  P.I. 02297790657</Box>

      </Box>
      ) 
}

function NotFound  (   ) {
  
 
 
     return (     
  
         <Box className="color_primary"  mt={4} display="flex" flexDirection="column" alignItems="center"  width="100%"     justifyContent="center"   > 

         <Box>Pagina non trovata</Box>
  
         </Box>
         ) 
 }


 function goTo (url)
 {
   //  window.location.href = "#/aiuto";
     window.open(url, "_blank") 
 }

 


function goToAiuto()
{
  //  window.location.href = "#/aiuto";
    window.open("#/aiuto", "_blank");
    
}

function  FooterView   ( props)  {

   
     return (
       <>
 <Box  width="100%"      display="flex" flexDirection="row" alignItems="center"  style={{backgroundColor:'#0d3880' }} 
        justifyContent="space-between"  className="color_primary" > 
  

 
      <Box  width="20%"  display="flex" flexDirection="row" alignItems="center" justifyContent="flex-start"  >
        <Box  >
          <IconButton aria-label="fingerprint"   onClick={ (event) => {goTo("https://www.facebook.com/portaleopendoctor/");event.preventDefault();}}  color="secondary">
            <img className="img-fluid" src={icona_facebook} alt="Facebook" />
          </IconButton>
        </Box> 

        <Box  >
          <IconButton aria-label="fingerprint"   onClick={ (event) => {goTo("https://www.instagram.com/opendoctor.it/");event.preventDefault();}}  color="secondary">
            <img className="img-fluid" src={icona_instagram}  style={{maxWidth: '32px', maxHeight:'32px'}}  alt="Instagram"/>
          </IconButton>
        </Box> 

        <Box  >
          <IconButton aria-label="fingerprint"   onClick={ (event) => {goTo("https://vimeo.com/momentomedico");event.preventDefault();}}  color="secondary">
            <img className="img-fluid" src={icona_vimeo}  style={{maxWidth: '32px', maxHeight:'32px'}} alt="Vimeo" />
          </IconButton>
        </Box> 
      </Box>  


      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center"         style={{fontSize: '90%', color: '#bfbfbf'}}> 

            <Box>
            <Link color="white" href="#" underline="none"  onClick={ (event) => {goTo("https://www.opendoctor.it/privacy.php");event.preventDefault();}} >
             Privacy
            </Link>&nbsp;|&nbsp;
            </Box> 
 
            <Box>
            <Link color="white" href="#" underline="none"  onClick={ (event) =>{goTo("https://www.opendoctor.it/termini.php");event.preventDefault(); }} > 
            Termini di utilizzo
            </Link>&nbsp;|&nbsp;
            </Box> 

            <Box>
            <Link color="white" href="#" underline="none"  onClick={ (event) => {goTo("https://www.opendoctor.it/informazioni-legali.php");event.preventDefault(); }} >
            Informazioni legali
            </Link>&nbsp;|&nbsp;
            </Box> 

            <Box>
            <Link color="white" href="#" underline="none"  onClick={ (event) => {goTo("https://security.opendoctor.it/application/utente/#/aiuto");event.preventDefault(); }} >
            Contatti/Assistenza 
            </Link>
            </Box> 

      </Box>

      <Box width="20%">&nbsp;</Box>

 </Box>
 </>
     )

 
 }


function  FooterViewSmart   ( props)  {

   
  return (
    <>
<Box  width="100%"      display="flex" flexDirection="column" alignItems="center" 
     justifyContent="space-between"    > 


 
   <Box display="flex" flexWrap="wrap" width="100%" p={1} flexDirection="row" alignItems="center" justifyContent="center" 
         style={{fontSize: '80%', color: '#bfbfbf' , backgroundColor:'#0d3880',   }}> 
         
         <Box>
            <Link color="white" href="#" underline="none"  onClick={ (event) => {goTo("https://www.opendoctor.it/privacy.php");event.preventDefault();}} >
             Privacy
            </Link>&nbsp;|&nbsp;
            </Box> 
 
            <Box>
            <Link color="white" href="#" underline="none"  onClick={ (event) => {goTo("https://www.opendoctor.it/termini.php");event.preventDefault();}} > 
            Termini di utilizzo
            </Link>&nbsp;|&nbsp;
            </Box> 

            <Box>
            <Link color="white" href="#" underline="none"  onClick={ (event) => {goTo("https://www.opendoctor.it/informazioni-legali.php");event.preventDefault();}} >
            Informazioni legali
            </Link>&nbsp;|&nbsp;
            </Box> 

            <Box>
            <Link color="white" href="#" underline="none"  onClick={ (event) => {goTo("https://security.opendoctor.it/application/utente/#/aiuto");event.preventDefault();}} >
            Contatti/Assistenza 
            </Link>
            </Box> 

   </Box> 


   <Box width="100%"  display="flex" flexDirection="row" alignItems="center" justifyContent="center"  >
     <Box  >
       <IconButton aria-label="fingerprint"   onClick={ (event) => {goTo("https://www.facebook.com/portaleopendoctor/");event.preventDefault();}}  color="secondary">
         <img className="img-fluid" src={icona_facebook}  alt="facebook"/>
       </IconButton>
     </Box> 

     <Box  >
       <IconButton aria-label="fingerprint"   onClick={ (event) => {goTo("https://www.instagram.com/opendoctor.it/");event.preventDefault();}}  color="secondary">
         <img className="img-fluid" src={icona_instagram}  style={{maxWidth: '32px', maxHeight:'32px'}} alt="Instagram"/>
       </IconButton>
     </Box> 

     <Box  >
       <IconButton aria-label="fingerprint"   onClick={ (event) => {goTo("https://vimeo.com/momentomedico");event.preventDefault();}}  color="secondary">
         <img className="img-fluid" src={icona_vimeo}  style={{maxWidth: '32px', maxHeight:'32px'}} alt="Vimeo" />
       </IconButton>
     </Box> 
   </Box>  

</Box>
</>
  )


}

export interface IProps { 
  history: any,
 
  
}
   
export interface IState {
  
 isInProgress: boolean;
 

}


 
class AppPage   extends React.Component <IProps,IState> {
 // unlisten: any;
  static contextType = ConfigContext;
  context!: React.ContextType<typeof ConfigContext>;

  constructor(props: any) 
  {
    super(props); 
    
    this.showHideAiuto = this.showHideAiuto.bind(this);
    
    this.state = {   isInProgress:false ,  }; 



 
  }

 
  showHideAiuto (location)
  {
 
  }

  
  
  
 
 
 

  render() {
 
 
    return (

<>
 


  
  <ThemeProvider theme={theme}>
     

          <Box  display="flex" flexDirection="row" alignItems="center" justifyContent="center">
                <NotificationContainer />
          </Box>

  
          <Box   display="flex" flexDirection="column" alignItems="center"  style={{backgroundColor:'#ffffff' }}    
                  justifyContent="space-between"  width="100%" height="100%" > 

            <Box  width={{ xs: '94%', sm: '90%' , md: '85%', lg: '75%', xl: '65%',}} 
             display="flex" flexDirection="column" alignItems="center" justifyContent="flex-start">


              <Box  width="100%"   mt={1}  display="flex" flexDirection="row" justifyContent="center" alignItems="center">
                  <img className="img-fluid " src={icona_testata_od}  style={{maxHeight:'91px', maxWidth: '375px'}} />
              </Box>


              <Box width="100%" mt={1} >



              <Routes>
  
  <Route  >
    <Route index element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}>
      <FlussoLogin/></React.Suspense>} />

 

      <Route  path='informaCollega/:provenienza/:id/:email/:hashEmail'   element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}>
        <InformaCollega  /></React.Suspense>} />

      <Route  path='informaCollega/:provenienza/:id'   element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}>
        <InformaCollega  /></React.Suspense>} />

 

      <Route  path='auth:authod_token'   element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}>
        <AuthSecurityOD  /></React.Suspense>} />

      <Route  path='login:url_provenienza'   element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}>
        <FlussoLogin showAlert={true}/></React.Suspense>} />
 

      <Route path='modificaFad:url_provenienza' 
        element={ <React.Suspense  fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}>
          <FlussoLogin showAlert={true} profilo="completo"/></React.Suspense>} />   
      <Route path='modificaFad' 
        element={ <React.Suspense  fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}>
          <FlussoLogin showAlert={true} profilo="completo"/></React.Suspense>} />   
      
      <Route path='registrazioneFad:url_provenienza'   
        element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><FlussoNewUtente profilo="completo"/></React.Suspense>} /> 
      <Route path='registrazioneFad'   
        element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><FlussoNewUtente profilo="completo"/></React.Suspense>} /> 

      <Route path='registrazione:url_provenienza'   element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><FlussoNewUtente/></React.Suspense>} />                              
      <Route path='registrazione'   element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><FlussoNewUtente/></React.Suspense>} />                              
      

      <Route path='resetPassword:url_provenienza' element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><RicordaPassword/></React.Suspense>} />                                  
      <Route path='resetPassword' element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><RicordaPassword/></React.Suspense>} />                            
      <Route path='ricordaPassword' element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><RicordaPassword/></React.Suspense>} />                            
     
      
      <Route path='cambioPassword:url_provenienza' element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><CambioPassword/></React.Suspense>} /> 
      <Route path='cambioPassword' element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><CambioPassword/></React.Suspense>} /> 
      <Route path='cambioPassword/:adminUser' element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><CambioPassword/></React.Suspense>} /> 
      <Route path='resetPassword/:email/:token' element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><CambioPassword/></React.Suspense>} /> 

      
      <Route path='aiuto' element={ <React.Suspense fallback={<Box mt={4}><CircularProgress color="primary" /></Box>}><AiutoView/></React.Suspense>} />   

      <Route path="*" element={<NotFound />} />
      
    </Route>
    
            </Routes>
 
             
              </Box>

            </Box>



            <Box  mt={1} display="flex" flexDirection="column" alignItems="center"     
                  justifyContent="space-between"  width="100%"  > 

{this.context.config.adminUser !== "" && this.props.history.location.hash !== "#/aiuto" &&
              <Box     >      
                <Tooltip title="Ha bisogno di assistenza? Clicchi quì" arrow placement="top-start">
                <IconButton aria-label="fingerprint"   onClick={goToAiuto}  color="secondary">
                  <AiutoLogo   className="icon-display" />
                </IconButton>
                </Tooltip>
              </Box>
          
  }


{this.context.config.adminUser == "" &&
<>
              <Box  mt={2}  mb={2}  width="100%" display={{xs:'none',   sm: 'none', md: 'flex' }}>
                  <FooterView  />
              </Box>
              <Box  mt={2}  mb={1}  width="100%"  display={{xs:'flex',   sm: 'flex', md: 'none' }}>
                  <FooterViewSmart />
              </Box>

              <Box   mb={1} mr={1} ml={1}  >
             <CopyWriteView />
              </Box>
              </>            
  }


            </Box>
          </Box>
 

          </ThemeProvider>
 
  
        
       
 

</>      
  )}
 
}
 
 


  
  export    {  AppPage as App } ; 
 
 